import type {DiffAnchor} from '@github-ui/diffs/types'
import {memo, type RefObject, useMemo} from 'react'

import {getDiffHunksData} from '../helpers/hunk-data-helpers'
import {useGridNavigation} from '../hooks/use-grid-navigation'
import type {DiffLine, ClientDiffLine, FileDiffReference} from '../types'
import UnifiedDiffRow from './UnifiedDiffRow'
import {useDiffLinesActions, useGetFirstLineSelectionOnDrag} from '../stores/selectors'
import type {ViewerData} from '../conversation-types'

const UnifiedDiffLines = memo(function UnifiedDiffLines({
  diffHasHiddenUnicodeCharacters,
  diffLines,
  fileAnchor,
  filePath,
  tableRef,
  showHiddenUnicode,
  copilotChatReference,
  viewerData,
}: {
  diffHasHiddenUnicodeCharacters: boolean
  diffLines: DiffLine[]
  fileLineCount: number
  fileAnchor: DiffAnchor
  filePath: string
  tableRef: RefObject<HTMLTableElement | null>
  showHiddenUnicode: boolean
  copilotChatReference?: FileDiffReference
  viewerData: ViewerData
}) {
  const hunksData = useMemo(() => getDiffHunksData(diffLines.map(diffLine => diffLine)), [diffLines])
  const {addLineToSelection, clearSelectedLines, selectMultipleLines} = useDiffLinesActions()
  const getfirstLineSelectionOnDrag = useGetFirstLineSelectionOnDrag()

  useGridNavigation({
    addLineToSelection,
    clearSelectedLines,
    containerRef: tableRef,
    fileAnchor,
    getfirstLineSelectionOnDrag,
    isSplitDiff: false,
    leftLines: diffLines as unknown as ClientDiffLine[],
    selectMultipleLines,
    disabled: false,
  })

  return (
    <>
      {diffLines.map((diffLine, index) => {
        const nextDiffLine = diffLines[index + 1]
        const prevDiffLine = diffLines[index - 1]
        const key = `unified-diff-row-l:${diffLine.left}-r:${diffLine.right}-b:${diffLine.blobLineNumber}`

        return (
          <UnifiedDiffRow
            copilotChatReference={copilotChatReference}
            diffHasHiddenUnicodeCharacters={diffHasHiddenUnicodeCharacters}
            filePath={filePath}
            hunksData={hunksData}
            currentDiffLine={diffLine}
            key={key}
            nextDiffLine={nextDiffLine}
            prevDiffLine={prevDiffLine}
            showHiddenUnicode={showHiddenUnicode}
            viewerData={viewerData}
          />
        )
      })}
    </>
  )
})

export default UnifiedDiffLines
